import Select, { SingleValue, StylesConfig } from 'react-select';

import type RegionType from '../../types/RegionType';

interface Props {
  regions: Array<RegionType>;
  onChange: (newRegion?: RegionType) => void;
  selectedRegion?: RegionType;
}

interface Option {
  label: string;
  value: number;
  latitude: number;
  longitude: number;
}

const RegionSelect: React.FC<Props> = ({
  regions,
  onChange,
  selectedRegion,
}) => {
  const options: Array<Option> = regions.map((region) => ({
    value: region.id,
    label: region.name,
    latitude: region.latitude,
    longitude: region.longitude,
  }));

  const customStyles: StylesConfig<Option> = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#ffc710' : '#005aa1',
      borderBottom: '1px solid #0c1837',
      color: state.isFocused
        ? '#0c1837'
        : state.isSelected
        ? '#ffc710'
        : '#fff',
      padding: 20,
    }),
    control: (provided, state) => {
      return {
        ...provided,
        background: 'transparent',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: state.menuIsOpen ? '#ffc710' : '#1f3267',
        height: '64px',
        borderRadius: 0,
        outline: 'none',
        boxShadow: 'none',
        '&:hover': {
          borderColor: state.menuIsOpen ? '#ffc710' : '#1f3267',
        },
      };
    },
    singleValue: (provided) => ({
      ...provided,
      color: '#fff',
      fontWeight: 'bold',
      paddingTop: 8,
      paddingBottom: 8,
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      paddingRight: 16,
      paddingLeft: 16,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
    menu: (provided) => ({
      ...provided,
      margin: 0,
    }),
  };

  return (
    <Select
      name="region"
      placeholder="Cała Polska"
      isSearchable={false}
      options={options}
      isMulti={false}
      styles={customStyles}
      value={
        selectedRegion
          ? {
              value: selectedRegion.id,
              label: selectedRegion.name,
              latitude: selectedRegion.latitude,
              longitude: selectedRegion.longitude,
            }
          : null
      }
      onChange={(item: SingleValue<Option>) => {
        if (item) {
          onChange({
            id: item.value,
            name: item.label,
            latitude: item.latitude,
            longitude: item.longitude,
          });
        } else {
          onChange(undefined);
        }
      }}
      components={{
        IndicatorSeparator: null,

        DropdownIndicator: () => (
          <svg
            height="16px"
            viewBox="0 0 512 512"
            width="16px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="#ffc710"
              d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9  c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3  z"
            />
          </svg>
        ),
      }}
    />
  );
};

export default RegionSelect;
